import { Host, h, } from "@stencil/core";
import state from "../store";
export class GxgTabs {
    constructor() {
        this.position = "top";
        this.height = "100%";
        this.maxHeight = "100%";
        this.minWidth = "200px";
        this.tabBarBorder = false;
        this.noBackground = false;
        this.noPadding = false;
        this.activeTab = "";
    }
    el;
    tabActivatedHandler(event) {
        event.stopPropagation();
        this.updateActiveChildren(event.target.tab, "gxg-tab-button");
        this.updateActiveChildren(event.target.tab, "gxg-tab");
    }
    componentWillLoad() {
        this.configureTabs();
    }
    updateActiveChildren(activeTab, tagName) {
        let children;
        if (tagName === "gxg-tab") {
            children = this.el.querySelectorAll(":scope > gxg-tab");
        }
        else if (tagName === "gxg-tab-button") {
            const tabBar = this.el.querySelector(":scope > gxg-tab-bar");
            children = tabBar.querySelectorAll(":scope > gxg-tab-button");
        }
        for (const child of children) {
            child.isSelected = activeTab === child.tab;
        }
    }
    configureTabs() {
        const tabs = this.el.querySelectorAll("gxg-tab");
        if (this.noPadding) {
            tabs.forEach((tab) => {
                tab.noPadding = true;
            });
        }
    }
    async setActiveTab(tab) {
        if (tab) {
            const tabEl = this.getTab(tab);
            if (!tabEl?.disabled) {
                this.updateActiveChildren(tab, "gxg-tab-button");
                this.updateActiveChildren(tab, "gxg-tab");
            }
        }
    }
    getTab = (tab) => {
        return this.el.querySelector(`gxg-tab-button[key=${tab}]`);
    };
    render() {
        return (h(Host, { style: {
                height: this.height,
                maxHeight: this.maxHeight,
                minWidth: this.minWidth,
            }, class: { mercury: state.mercury } }, h("div", { class: "main-container" }, this.position === "bottom"
            ? [
                h("div", { class: "tabs-container" }, h("slot", null)),
                h("div", { class: "tab-bar-container" }, h("slot", { name: "tab-bar-container" })),
            ]
            : [
                h("div", { class: "tab-bar-container" }, h("slot", { name: "tab-bar-container" })),
                h("div", { class: "tabs-container" }, h("slot", null)),
            ])));
    }
    static get is() { return "gxg-tabs"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabs.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabs.css"]
        };
    }
    static get properties() {
        return {
            "position": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TabsPosition",
                    "resolved": "\"bottom\" | \"left\" | \"right\" | \"top\"",
                    "references": {
                        "TabsPosition": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/tabs/tabs.tsx",
                            "id": "src/components/tabs/tabs.tsx::TabsPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "position",
                "reflect": false,
                "defaultValue": "\"top\""
            },
            "height": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "height",
                "reflect": true,
                "defaultValue": "\"100%\""
            },
            "maxHeight": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "max-height",
                "reflect": false,
                "defaultValue": "\"100%\""
            },
            "minWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "min-width",
                "reflect": false,
                "defaultValue": "\"200px\""
            },
            "tabBarBorder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "tab-bar-border",
                "reflect": false,
                "defaultValue": "false"
            },
            "noBackground": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute removes the background color (only for mercury)"
                },
                "attribute": "no-background",
                "reflect": true,
                "defaultValue": "false"
            },
            "noPadding": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute removes each tab .container padding"
                },
                "attribute": "no-padding",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "activeTab": {}
        };
    }
    static get methods() {
        return {
            "setActiveTab": {
                "complexType": {
                    "signature": "(tab: string) => Promise<void>",
                    "parameters": [{
                            "name": "tab",
                            "type": "string",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "tabActivated",
                "method": "tabActivatedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=tabs.js.map
